var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('h1',[_vm._v(_vm._s(_vm.lang.Serials))]),_c('SerialsList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }